import { z } from 'zod';

export const useStepThreeValidation = () => {
	const problemSchema = z.object({
		execution: z.preprocess(
			(value) => (value === '' ? undefined : Number(value)),
			z.number({ required_error: 'Обязательное поле' }).min(1).max(10),
		),
		satisfaction: z.preprocess(
			(value) => (value === '' ? undefined : Number(value)),
			z.number({ required_error: 'Обязательное поле' }).min(1).max(10),
		),
		problemId: z.number().nullable().optional(),
	});

	const stepThreeSchema = z.object({
		patientCardId: z.number().nullable().optional(),
		goal: z.string().min(1).optional(),
		// goalPlan: z.string().optional(),
		estimateHistories: z.array(problemSchema),
		dateNextInterview: z.string().optional(),
	});

	return { stepThreeSchema };
};
export type StepThreeInfo = z.input<ReturnType<typeof useStepThreeValidation>['stepThreeSchema']>;
